class NumberFormatter {
  static ADOSZAM = {
    lepesszam: 8,
  };

  static ADOSZAMAZON = {
    lepesszam: 10,
  };

  static BANKSZAMLA = {
    lepesszam: 8,
  };

  static IBAN = {
    lepesszam: 4,
  };

  static OSSZEG = {
    lepesszam: 3,
  };

  static EGYSEGAR = {
    lepesszam: 6,
  };

  static MENNYISEG = {
    lepesszam: 3,
  };

  static TAJSZAM = {
    lepesszam: 3,
  };

  static formatterSpaceOsszegPenznem = (cell, row, jel) => {
    let penznemJel = row && row.penznem ? row.penznem.jel : '';
    penznemJel = jel || penznemJel;
    return (NumberFormatter.addSpacesToString(cell, NumberFormatter.OSSZEG) + '\u00A0' + penznemJel).trim(); // '\u00A0' == &nbsp;
  }

  static formatterSpaceOsszeg = (cell) => {
    return NumberFormatter.addSpacesToString(cell, NumberFormatter.OSSZEG);
  }

  static styleTextAlign = () => {
    return { textAlign: 'right' };
  }

  static styleTextAlignWhiteSpace = () => {
    return { whiteSpace: 'pre-line', textAlign: 'right' };
  }

  static addHyphensToString = (string) => {
    if (string) {
      if (string.indexOf('-') > -1)
        string = NumberFormatter.removeHyphensFromString(string);
      return string.slice(0, 8) + (string.length >= 8 ? '-' : '') + string.slice(8, 9) + (string.length >= 9 ? '-' : '') + string.slice(9, 11);
    }
  }

  static addHyphensToStringBankszamla = (string) => {
    if (string) {
      if (string.indexOf('-') > -1) {
        string = NumberFormatter.removeHyphensFromString(string);
      }
      return string.slice(0, 8) + (string.length > 8 ? '-' : '') + string.slice(8, 16) + (string.length > 16 ? '-' : '') + string.slice(16);
    }
  }

  static addHyphensToStringIBAN = (string) => {
    if (string) {
      if (string.indexOf('-') > -1) {
        string = NumberFormatter.removeHyphensFromString(string);
      }
      return string.slice(0, 4)
        + (string.length > 4 ? '-' : '') + string.slice(4, 8) 
        + (string.length > 8 ? '-' : '') + string.slice(8, 12)
        + (string.length > 12 ? '-' : '') + string.slice(12, 16)
        + (string.length > 16 ? '-' : '') + string.slice(16, 20)
        + (string.length > 20 ? '-' : '') + string.slice(20, 24)
        + (string.length > 24 ? '-' : '') + string.slice(24);
    }
  }

  static addSpacesToString = (eredetiString, tipus, returnEmptyStringOnZero) => {
    if (eredetiString == "0") {
      if (returnEmptyStringOnZero)
        return '';
      else
        return '0';
    } else if (eredetiString && tipus && tipus.lepesszam) {
      eredetiString += '';
      eredetiString = NumberFormatter.removeSpacesFromString(eredetiString);
      let levagottKarakter = "";
      if (eredetiString.charAt(0) == '-') {
        levagottKarakter = eredetiString.slice(0, 1);
        eredetiString = eredetiString.slice(1);
      }
      let string = eredetiString, valaszto = -1;
      if (tipus == NumberFormatter.OSSZEG || tipus == NumberFormatter.EGYSEGAR || tipus == NumberFormatter.MENNYISEG) {
        valaszto = string.indexOf('.');
        if (valaszto > -1) {
          string = string.slice(0, valaszto);
        }
      }
      let array = string.split('');
      for (let i = array.length - 1, o = 1; i >= 0; i-- , o++) {
        if (o % tipus.lepesszam == 0 && i != 0) {
          array.splice(i, 0, '\u00A0'); // '\u00A0' == &nbsp;
        }
      }
      return levagottKarakter + array.join('') + (valaszto > -1 ? eredetiString.slice(valaszto) : '');
    }
  }

  static removeSpacesFromString = (string) => {
    if (string || string === 0) {
      string += '';
      return string.replace(/\s/g, '');
    }

    return string;
  }

  static removeHyphensFromString = (string) => {
    if (string || string === 0) {
      return string.replace(/-/g, '');
    }

    return string;
  }

  // Ha van pont a számban, akkor levágja az utolsó 0-kat, valamint a pontot is, ha csupa 0-ra végződik
  static removeRedundantZeros = (s) => {
    s += '';
    if (s && s.indexOf('.') > -1) {
      const regex = /\.?0*$/;
      return s.replace(regex, '');
    }
    return s;
  };

}
export default NumberFormatter;
